export default {
  name: 'WrapHtml',
  render(h) {
    const [{ text } = {}] = this.$slots.default
    if (!text) return null
    return h('RawHtml', { props: { html: text } })
  }
}
